import { Singleton } from '@tunein/web-utils';
import { createAppStore, createFavoritesStore, createPlayerStore, createUserStore } from './';
import type { InitialStoreState, IStores } from './types';

export class Stores extends Singleton<IStores> {
  init(initialState: InitialStoreState) {
    this.instance = {
      appStore: createAppStore(initialState?.appStore),
      playerStore: createPlayerStore(initialState?.playerStore),
      favoritesStore: createFavoritesStore(initialState?.favoritesStore),
      userStore: createUserStore(initialState?.userStore),
    };
  }
}
